exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  display: block;\n  padding: 0 16px;\n}\n\nh2 {\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 0.005em;\n  margin-bottom: 0;\n  margin-top: 0.83em;\n}\n\n.sample_img {\n  -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */\n  filter: grayscale(100%);\n}\n\n.sample_text {\n  top: -122px;\n  position: relative;\n  font-size: 24px;\n  font-weight: bold;\n  color: #000;\n  -webkit-text-stroke-width: 1px;\n  -webkit-text-stroke-color: #FFF;\n}\n\n#photo_alert {\n  display: none;\n}\n\n.photo-area .photo-head {\n  height: 20%;\n}\n\n.photo-area .photo-body {\n  height: 80%;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n\n.photo-area .btn-area {\n  margin: 20px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/rubylover/Work/new_vin_photo/site/web/src/app/photo/photo.component.css
// module id = ../../../../../src/app/photo/photo.component.css
// module chunks = main